import $ from 'jquery';
import { PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
import PaymentCalculatorForm from '../../components/payment-calc/payment-calculator.js';
import './nasapi-calculator.js';
import { InventorySearchEvents } from '@dealersites/inventory/events';
import { runNasapi } from '../payment-calc/nasapi-calculator.js';
import { formatPrice } from '@oem-theme/utilities.js';

const formatSRPPrice = formatPrice.custom(['srp']);
const validFrequencies = ['weekly', 'biweekly', 'monthly']

const $site = $('.site');
let FREQUENCY = $site.data('frequency')

if (!validFrequencies.includes(FREQUENCY)) {
  FREQUENCY = "biweekly";
}


// Payment Calculation
//Finance/Lease payments on VLP

function runSRPPayments() {

  $('.vehiclePayments .js-payment').each(function (index) {
    let $payment = $(this);
    let calcInputs = {
      price: $payment.data('price'),
      down: $payment.data('down'),
      term: $payment.data('term'),
      rate: $payment.data('rate'),
      tradein: $payment.data('tradein'),
    };

    const calculatorType = $payment.data('calculator');
    const includeTax = $payment.data('include-tax');
    const tax = parseInt($payment.data('tax'));

  
    calcInputs.tax = includeTax ? tax : 0;
    
    if (calculatorType === 'lease') {
      calcInputs.residual = $payment.data('residual');
    }

    if (['finance', 'lease'].includes(calculatorType)) {
      const newCalc = PaymentCalculatorFactory.createCalculator(calculatorType, calcInputs);

      newCalc.calculate();
      $payment.text(formatSRPPrice(newCalc.payments[FREQUENCY]));
    }
  });

}

document.addEventListener('DOMContentLoaded', runSRPPayments);

//re-run on Filter

$(document).on(InventorySearchEvents.POST_RENDER, function() {
  runSRPPayments();
  runNasapi();
})

//  Finance/Lease payment calculator on VDP

let financeInfoBtn = $('#show-finance-info');
let leaseInfoBtn = $('#show-lease-info');
let financeInfo = $('.finance-info');
let leaseInfo = $('.lease-info');

function handleFinanceInfoShow(btn, div) {
  $('.finance-lease-button').removeClass('active');
  $('.calculator-info').removeClass('show');

  btn.addClass('active');
  div.addClass('show');
}

financeInfoBtn.on('click', function () {
  handleFinanceInfoShow(financeInfoBtn, financeInfo);
});

leaseInfoBtn.on('click', function () {
  handleFinanceInfoShow(leaseInfoBtn, leaseInfo);
});

document.addEventListener('DOMContentLoaded', () => {
  new PaymentCalculatorForm('js-calc-small-', ['vdp']);
});
